import {
  FOOD_PREORDER_EVENT_LIST,
  FOOD_PREORDER_EVENT_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_LIST_FAIL,
  FOOD_PREORDER_EVENT_SEARCH,
  FOOD_PREORDER_EVENT_SEARCH_SUCCESS,
  FOOD_PREORDER_EVENT_SEARCH_FAIL,
  FOOD_PREORDER_EVENT_DATA,
  FOOD_PREORDER_EVENT_DATA_SUCCESS,
  FOOD_PREORDER_EVENT_DATA_FAIL,
  FOOD_PREORDER_EVENT_CREATE,
  FOOD_PREORDER_EVENT_CREATE_SUCCESS,
  FOOD_PREORDER_EVENT_CREATE_FAIL,
  FOOD_PREORDER_EVENT_UPDATE,
  FOOD_PREORDER_EVENT_UPDATE_SUCCESS,
  FOOD_PREORDER_EVENT_UPDATE_FAIL,
  FOOD_PREORDER_EVENT_DELETE,
  FOOD_PREORDER_EVENT_DELETE_SUCCESS,
  FOOD_PREORDER_EVENT_DELETE_FAIL,
  FOOD_PREORDER_EVENT_GUEST_LIST,
  FOOD_PREORDER_EVENT_GUEST_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_LIST_FAIL,
  FOOD_PREORDER_EVENT_GUEST_SEARCH,
  FOOD_PREORDER_EVENT_GUEST_SEARCH_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_SEARCH_FAIL,
  FOOD_PREORDER_EVENT_GUEST_DATA,
  FOOD_PREORDER_EVENT_GUEST_DATA_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_DATA_FAIL,
  FOOD_PREORDER_EVENT_GUEST_INVITE,
  FOOD_PREORDER_EVENT_GUEST_INVITE_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_INVITE_FAIL,
  FOOD_PREORDER_EVENT_GUEST_DELETE,
  FOOD_PREORDER_EVENT_GUEST_DELETE_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_DELETE_FAIL,
  FOOD_MENU_STATUS_LIST,
  FOOD_MENU_STATUS_LIST_SUCCESS,
  FOOD_MENU_STATUS_LIST_FAIL,
  FOOD_MENU_STATUS_DATA,
  FOOD_MENU_STATUS_DATA_SUCCESS,
  FOOD_MENU_STATUS_DATA_FAIL,
  FOOD_MENU_STATUS_CREATE,
  FOOD_MENU_STATUS_CREATE_SUCCESS,
  FOOD_MENU_STATUS_CREATE_FAIL,
  FOOD_MENU_STATUS_UPDATE,
  FOOD_MENU_STATUS_UPDATE_SUCCESS,
  FOOD_MENU_STATUS_UPDATE_FAIL,
  FOOD_MENU_STATUS_DELETE,
  FOOD_MENU_STATUS_DELETE_SUCCESS,
  FOOD_MENU_STATUS_DELETE_FAIL,
  FOOD_MENU_LIST,
  FOOD_MENU_LIST_SUCCESS,
  FOOD_MENU_LIST_FAIL,
  FOOD_MENU_DATA,
  FOOD_MENU_DATA_SUCCESS,
  FOOD_MENU_DATA_FAIL,
  FOOD_MENU_CREATE,
  FOOD_MENU_CREATE_SUCCESS,
  FOOD_MENU_CREATE_FAIL,
  FOOD_MENU_UPDATE,
  FOOD_MENU_UPDATE_SUCCESS,
  FOOD_MENU_UPDATE_FAIL,
  FOOD_MENU_DELETE,
  FOOD_MENU_DELETE_SUCCESS,
  FOOD_MENU_DELETE_FAIL,
  FOOD_MENU_CATEGORY_LIST,
  FOOD_MENU_CATEGORY_LIST_SUCCESS,
  FOOD_MENU_CATEGORY_LIST_FAIL,
  FOOD_MENU_CATEGORY_DATA,
  FOOD_MENU_CATEGORY_DATA_SUCCESS,
  FOOD_MENU_CATEGORY_DATA_FAIL,
  FOOD_MENU_CATEGORY_CREATE,
  FOOD_MENU_CATEGORY_CREATE_SUCCESS,
  FOOD_MENU_CATEGORY_CREATE_FAIL,
  FOOD_MENU_CATEGORY_UPDATE,
  FOOD_MENU_CATEGORY_UPDATE_SUCCESS,
  FOOD_MENU_CATEGORY_UPDATE_FAIL,
  FOOD_MENU_CATEGORY_DELETE,
  FOOD_MENU_CATEGORY_DELETE_SUCCESS,
  FOOD_MENU_CATEGORY_DELETE_FAIL,
  FOOD_MENU_ITEM_LIST,
  FOOD_MENU_ITEM_LIST_SUCCESS,
  FOOD_MENU_ITEM_LIST_FAIL,
  FOOD_MENU_ITEM_DATA,
  FOOD_MENU_ITEM_DATA_SUCCESS,
  FOOD_MENU_ITEM_DATA_FAIL,
  FOOD_MENU_ITEM_CREATE,
  FOOD_MENU_ITEM_CREATE_SUCCESS,
  FOOD_MENU_ITEM_CREATE_FAIL,
  FOOD_MENU_ITEM_UPDATE,
  FOOD_MENU_ITEM_UPDATE_SUCCESS,
  FOOD_MENU_ITEM_UPDATE_FAIL,
  FOOD_MENU_ITEM_DELETE,
  FOOD_MENU_ITEM_DELETE_SUCCESS,
  FOOD_MENU_ITEM_DELETE_FAIL,
  FOOD_PREORDER_EVENT_STATUS_LIST,
  FOOD_PREORDER_EVENT_STATUS_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_STATUS_LIST_FAIL,
  FOOD_PREORDER_EVENT_STATUS_DATA,
  FOOD_PREORDER_EVENT_STATUS_DATA_SUCCESS,
  FOOD_PREORDER_EVENT_STATUS_DATA_FAIL,
  FOOD_PREORDER_EVENT_STATUS_CREATE,
  FOOD_PREORDER_EVENT_STATUS_CREATE_SUCCESS,
  FOOD_PREORDER_EVENT_STATUS_CREATE_FAIL,
  FOOD_PREORDER_EVENT_STATUS_UPDATE,
  FOOD_PREORDER_EVENT_STATUS_UPDATE_SUCCESS,
  FOOD_PREORDER_EVENT_STATUS_UPDATE_FAIL,
  FOOD_PREORDER_EVENT_STATUS_DELETE,
  FOOD_PREORDER_EVENT_STATUS_DELETE_SUCCESS,
  FOOD_PREORDER_EVENT_STATUS_DELETE_FAIL,
  FOOD_PREORDER_EVENT_TYPE_LIST,
  FOOD_PREORDER_EVENT_TYPE_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_TYPE_LIST_FAIL,
  FOOD_PREORDER_EVENT_TYPE_DATA,
  FOOD_PREORDER_EVENT_TYPE_DATA_SUCCESS,
  FOOD_PREORDER_EVENT_TYPE_DATA_FAIL,
  FOOD_PREORDER_EVENT_TYPE_CREATE,
  FOOD_PREORDER_EVENT_TYPE_CREATE_SUCCESS,
  FOOD_PREORDER_EVENT_TYPE_CREATE_FAIL,
  FOOD_PREORDER_EVENT_TYPE_UPDATE,
  FOOD_PREORDER_EVENT_TYPE_UPDATE_SUCCESS,
  FOOD_PREORDER_EVENT_TYPE_UPDATE_FAIL,
  FOOD_PREORDER_EVENT_TYPE_DELETE,
  FOOD_PREORDER_EVENT_TYPE_DELETE_SUCCESS,
  FOOD_PREORDER_EVENT_TYPE_DELETE_FAIL,
  FOOD_MENU_TYPE_LIST,
  FOOD_MENU_TYPE_LIST_SUCCESS,
  FOOD_MENU_TYPE_LIST_FAIL,
  FOOD_MENU_TYPE_DATA,
  FOOD_MENU_TYPE_DATA_SUCCESS,
  FOOD_MENU_TYPE_DATA_FAIL,
  FOOD_MENU_TYPE_CREATE,
  FOOD_MENU_TYPE_CREATE_SUCCESS,
  FOOD_MENU_TYPE_CREATE_FAIL,
  FOOD_MENU_TYPE_UPDATE,
  FOOD_MENU_TYPE_UPDATE_SUCCESS,
  FOOD_MENU_TYPE_UPDATE_FAIL,
  FOOD_MENU_TYPE_DELETE,
  FOOD_MENU_TYPE_DELETE_SUCCESS,
  FOOD_MENU_TYPE_DELETE_FAIL,
  FOOD_PREORDER_SITE_LOCATION_LIST,
  FOOD_PREORDER_SITE_LOCATION_LIST_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_LIST_FAIL,
  FOOD_PREORDER_SITE_LOCATION_DATA,
  FOOD_PREORDER_SITE_LOCATION_DATA_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_DATA_FAIL,
  FOOD_PREORDER_SITE_LOCATION_CREATE,
  FOOD_PREORDER_SITE_LOCATION_CREATE_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_CREATE_FAIL,
  FOOD_PREORDER_SITE_LOCATION_UPDATE,
  FOOD_PREORDER_SITE_LOCATION_UPDATE_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_UPDATE_FAIL,
  FOOD_PREORDER_SITE_LOCATION_DELETE,
  FOOD_PREORDER_SITE_LOCATION_DELETE_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_DELETE_FAIL,
  FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE,
  FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE_FAIL,
  FOOD_PREORDER_EVENT_GUEST_ACCEPT,
  FOOD_PREORDER_EVENT_GUEST_ACCEPT_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_ACCEPT_FAIL,
  FOOD_PREORDER_EVENT_GUEST_DECLINE,
  FOOD_PREORDER_EVENT_GUEST_DECLINE_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_DECLINE_FAIL,
  FOOD_MENU_SEARCH,
  FOOD_MENU_SEARCH_SUCCESS,
  FOOD_MENU_SEARCH_FAIL,
  FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY,
  FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY_SUCCESS,
  FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY_FAIL,
  FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND,
  FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND_FAIL,
  FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED,
  FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED_SUCCESS,
  FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED_FAIL,
  FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN,
  FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN_SUCCESS,
  FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN_FAIL,
  FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS,
  FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS_SUCCESS,
  FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS_FAIL,
  FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST,
  FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_FAIL,
  FOOD_PREORDER_EVENT_COMMUNICATION_LIST,
  FOOD_PREORDER_EVENT_COMMUNICATION_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_COMMUNICATION_LIST_FAIL,
  FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH,
  FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH_SUCCESS,
  FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH_FAIL,
  FOOD_PREORDER_EVENT_ATTACHMENT_DELETE,
  FOOD_PREORDER_EVENT_ATTACHMENT_DELETE_SUCCESS,
  FOOD_PREORDER_EVENT_ATTACHMENT_DELETE_FAIL,
  FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY,
  FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY_SUCCESS,
  FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY_FAIL,
  FOOD_MENU_ITEM_SEARCH,
  FOOD_MENU_ITEM_SEARCH_SUCCESS,
  FOOD_MENU_ITEM_SEARCH_FAIL,
  FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN,
  FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS,
  FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN_FAIL,
  FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST,
  FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST_FAIL,
  FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH,
  FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH_FAIL,
  FOOD_PREORDER_EVENT_GROUP_LIST,
  FOOD_PREORDER_EVENT_GROUP_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_LIST_FAIL,
  FOOD_PREORDER_EVENT_GROUP_DATA,
  FOOD_PREORDER_EVENT_GROUP_DATA_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_DATA_FAIL,
  FOOD_PREORDER_EVENT_GROUP_CREATE,
  FOOD_PREORDER_EVENT_GROUP_CREATE_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_CREATE_FAIL,
  FOOD_PREORDER_EVENT_GROUP_UPDATE,
  FOOD_PREORDER_EVENT_GROUP_UPDATE_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_UPDATE_FAIL,
  FOOD_PREORDER_EVENT_GROUP_DELETE,
  FOOD_PREORDER_EVENT_GROUP_DELETE_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_DELETE_FAIL,
  FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA,
  FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA_SUCCESS,
  FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA_FAIL,
  FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN,
  FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN_FAIL,
  FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN,
  FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN_FAIL,
  FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS,
  FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS_FAIL,
  FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED,
  FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED_FAIL,
  FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST,
  FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST_FAIL,
  FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN,
  FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN_FAIL,
  FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN,
  FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN_FAIL,
  FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED,
  FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED_FAIL,
  FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST,
  FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST_FAIL,
  FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN,
  FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN_SUCCESS,
  FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN_FAIL,
  FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN,
  FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS,
  FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN_FAIL,
  FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED,
  FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED_SUCCESS,
  FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED_FAIL,
  FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE,
  FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE_FAIL,
  FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE,
  FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE_FAIL,
  FOOD_PREORDER_SITE_LOCATION_SEARCH,
  FOOD_PREORDER_SITE_LOCATION_SEARCH_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_SEARCH_FAIL,
  FOOD_MENU_CLONE,
  FOOD_MENU_CLONE_SUCCESS,
  FOOD_MENU_CLONE_FAIL,
} from "./actionType";

// FOOD_PREORDER_EVENT_LIST
export const foodPreOrderEventList = (payload) => ({
  type: FOOD_PREORDER_EVENT_LIST,
  payload,
});

export const foodPreOrderEventListSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_LIST_SUCCESS,
  payload,
});

export const foodPreOrderEventListFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_LIST_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_SEARCH
export const foodPreOrderEventSearch = (payload) => ({
  type: FOOD_PREORDER_EVENT_SEARCH,
  payload,
});

export const foodPreOrderEventSearchSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_SEARCH_SUCCESS,
  payload,
});

export const foodPreOrderEventSearchFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_SEARCH_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_DATA
export const foodPreOrderEventData = (payload, token) => ({
  type: FOOD_PREORDER_EVENT_DATA,
  payload,
  token,
});

export const foodPreOrderEventDataSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_DATA_SUCCESS,
  payload,
});

export const foodPreOrderEventDataFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_DATA_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_CREATE
export const foodPreOrderEventCreate = (payload) => ({
  type: FOOD_PREORDER_EVENT_CREATE,
  payload,
});

export const foodPreOrderEventCreateSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_CREATE_SUCCESS,
  payload,
});

export const foodPreOrderEventCreateFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_CREATE_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_UPDATE
export const foodPreOrderEventUpdate = (payload) => ({
  type: FOOD_PREORDER_EVENT_UPDATE,
  payload,
});

export const foodPreOrderEventUpdateSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_UPDATE_SUCCESS,
  payload,
});

export const foodPreOrderEventUpdateFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_UPDATE_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_DELETE
export const foodPreOrderEventDelete = (payload) => ({
  type: FOOD_PREORDER_EVENT_DELETE,
  payload,
});

export const foodPreOrderEventDeleteSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_DELETE_SUCCESS,
  payload,
});

export const foodPreOrderEventDeleteFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_DELETE_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GUEST_LIST
export const foodPreOrderEventGuestList = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_LIST,
  payload,
});

export const foodPreOrderEventGuestListSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_LIST_SUCCESS,
  payload,
});

export const foodPreOrderEventGuestListFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_LIST_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GUEST_SEARCH
export const foodPreOrderEventGuestSearch = (payload, token) => ({
  type: FOOD_PREORDER_EVENT_GUEST_SEARCH,
  payload,
  token,
});

export const foodPreOrderEventGuestSearchSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_SEARCH_SUCCESS,
  payload,
});

export const foodPreOrderEventGuestSearchFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_SEARCH_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GUEST_DATA
export const foodPreOrderEventGuestData = (payload, token) => ({
  type: FOOD_PREORDER_EVENT_GUEST_DATA,
  payload,
  token,
});

export const foodPreOrderEventGuestDataSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_DATA_SUCCESS,
  payload,
});

export const foodPreOrderEventGuestDataFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_DATA_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GUEST_INVITE
export const foodPreOrderEventGuestInvite = (payload, token) => ({
  type: FOOD_PREORDER_EVENT_GUEST_INVITE,
  payload,
  token,
});

export const foodPreOrderEventGuestInviteSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_INVITE_SUCCESS,
  payload,
});

export const foodPreOrderEventGuestInviteFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_INVITE_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GUEST_DELETE
export const foodPreOrderEventGuestDelete = (payload, token) => ({
  type: FOOD_PREORDER_EVENT_GUEST_DELETE,
  payload,
  token,
});

export const foodPreOrderEventGuestDeleteSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_DELETE_SUCCESS,
  payload,
});

export const foodPreOrderEventGuestDeleteFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_DELETE_FAIL,
  payload,
});

// FOOD_MENU_STATUS_LIST
export const foodMenuStatusList = (payload) => ({
  type: FOOD_MENU_STATUS_LIST,
  payload,
});

export const foodMenuStatusListSuccess = (payload) => ({
  type: FOOD_MENU_STATUS_LIST_SUCCESS,
  payload,
});

export const foodMenuStatusListFail = (payload) => ({
  type: FOOD_MENU_STATUS_LIST_FAIL,
  payload,
});

// FOOD_MENU_STATUS_DATA
export const foodMenuStatusData = (payload) => ({
  type: FOOD_MENU_STATUS_DATA,
  payload,
});

export const foodMenuStatusDataSuccess = (payload) => ({
  type: FOOD_MENU_STATUS_DATA_SUCCESS,
  payload,
});

export const foodMenuStatusDataFail = (payload) => ({
  type: FOOD_MENU_STATUS_DATA_FAIL,
  payload,
});

// FOOD_MENU_STATUS_CREATE
export const foodMenuStatusCreate = (payload) => ({
  type: FOOD_MENU_STATUS_CREATE,
  payload,
});

export const foodMenuStatusCreateSuccess = (payload) => ({
  type: FOOD_MENU_STATUS_CREATE_SUCCESS,
  payload,
});

export const foodMenuStatusCreateFail = (payload) => ({
  type: FOOD_MENU_STATUS_CREATE_FAIL,
  payload,
});

// FOOD_MENU_STATUS_UPDATE
export const foodMenuStatusUpdate = (payload) => ({
  type: FOOD_MENU_STATUS_UPDATE,
  payload,
});

export const foodMenuStatusUpdateSuccess = (payload) => ({
  type: FOOD_MENU_STATUS_UPDATE_SUCCESS,
  payload,
});

export const foodMenuStatusUpdateFail = (payload) => ({
  type: FOOD_MENU_STATUS_UPDATE_FAIL,
  payload,
});

// FOOD_MENU_STATUS_DELETE
export const foodMenuStatusDelete = (payload) => ({
  type: FOOD_MENU_STATUS_DELETE,
  payload,
});

export const foodMenuStatusDeleteSuccess = (payload) => ({
  type: FOOD_MENU_STATUS_DELETE_SUCCESS,
  payload,
});

export const foodMenuStatusDeleteFail = (payload) => ({
  type: FOOD_MENU_STATUS_DELETE_FAIL,
  payload,
});

// FOOD_MENU_LIST
export const foodMenuList = () => ({
  type: FOOD_MENU_LIST,
});

export const foodMenuListSuccess = (payload) => ({
  type: FOOD_MENU_LIST_SUCCESS,
  payload,
});

export const foodMenuListFail = (payload) => ({
  type: FOOD_MENU_LIST_FAIL,
  payload,
});

// FOOD_MENU_DATA
export const foodMenuData = (payload) => ({
  type: FOOD_MENU_DATA,
  payload,
});

export const foodMenuDataSuccess = (payload) => ({
  type: FOOD_MENU_DATA_SUCCESS,
  payload,
});

export const foodMenuDataFail = (payload) => ({
  type: FOOD_MENU_DATA_FAIL,
  payload,
});

// FOOD_MENU_CREATE
export const foodMenuCreate = (payload) => ({
  type: FOOD_MENU_CREATE,
  payload,
});

export const foodMenuCreateSuccess = (payload) => ({
  type: FOOD_MENU_CREATE_SUCCESS,
  payload,
});

export const foodMenuCreateFail = (payload) => ({
  type: FOOD_MENU_CREATE_FAIL,
  payload,
});

// FOOD_MENU_UPDATE
export const foodMenuUpdate = (payload) => ({
  type: FOOD_MENU_UPDATE,
  payload,
});

export const foodMenuUpdateSuccess = (payload) => ({
  type: FOOD_MENU_UPDATE_SUCCESS,
  payload,
});

export const foodMenuUpdateFail = (payload) => ({
  type: FOOD_MENU_UPDATE_FAIL,
  payload,
});

// FOOD_MENU_DELETE
export const foodMenuDelete = (payload) => ({
  type: FOOD_MENU_DELETE,
  payload,
});

export const foodMenuDeleteSuccess = (payload) => ({
  type: FOOD_MENU_DELETE_SUCCESS,
  payload,
});

export const foodMenuDeleteFail = (payload) => ({
  type: FOOD_MENU_DELETE_FAIL,
  payload,
});

// FOOD_MENU_CATEGORY_LIST
export const foodMenuCategoryList = (payload) => ({
  type: FOOD_MENU_CATEGORY_LIST,
  payload,
});

export const foodMenuCategoryListSuccess = (payload) => ({
  type: FOOD_MENU_CATEGORY_LIST_SUCCESS,
  payload,
});

export const foodMenuCategoryListFail = (payload) => ({
  type: FOOD_MENU_CATEGORY_LIST_FAIL,
  payload,
});

// FOOD_MENU_CATEGORY_DATA
export const foodMenuCategoryData = (payload) => ({
  type: FOOD_MENU_CATEGORY_DATA,
  payload,
});

export const foodMenuCategoryDataSuccess = (payload) => ({
  type: FOOD_MENU_CATEGORY_DATA_SUCCESS,
  payload,
});

export const foodMenuCategoryDataFail = (payload) => ({
  type: FOOD_MENU_CATEGORY_DATA_FAIL,
  payload,
});

// FOOD_MENU_CATEGORY_CREATE
export const foodMenuCategoryCreate = (payload) => ({
  type: FOOD_MENU_CATEGORY_CREATE,
  payload,
});

export const foodMenuCategoryCreateSuccess = (payload) => ({
  type: FOOD_MENU_CATEGORY_CREATE_SUCCESS,
  payload,
});

export const foodMenuCategoryCreateFail = (payload) => ({
  type: FOOD_MENU_CATEGORY_CREATE_FAIL,
  payload,
});

// FOOD_MENU_CATEGORY_UPDATE
export const foodMenuCategoryUpdate = (payload) => ({
  type: FOOD_MENU_CATEGORY_UPDATE,
  payload,
});

export const foodMenuCategoryUpdateSuccess = (payload) => ({
  type: FOOD_MENU_CATEGORY_UPDATE_SUCCESS,
  payload,
});

export const foodMenuCategoryUpdateFail = (payload) => ({
  type: FOOD_MENU_CATEGORY_UPDATE_FAIL,
  payload,
});

// FOOD_MENU_CATEGORY_DELETE
export const foodMenuCategoryDelete = (payload) => ({
  type: FOOD_MENU_CATEGORY_DELETE,
  payload,
});

export const foodMenuCategoryDeleteSuccess = (payload) => ({
  type: FOOD_MENU_CATEGORY_DELETE_SUCCESS,
  payload,
});

export const foodMenuCategoryDeleteFail = (payload) => ({
  type: FOOD_MENU_CATEGORY_DELETE_FAIL,
  payload,
});

// FOOD_MENU_ITEM_LIST
export const foodMenuItemList = (payload) => ({
  type: FOOD_MENU_ITEM_LIST,
  payload,
});

export const foodMenuItemListSuccess = (payload) => ({
  type: FOOD_MENU_ITEM_LIST_SUCCESS,
  payload,
});

export const foodMenuItemListFail = (payload) => ({
  type: FOOD_MENU_ITEM_LIST_FAIL,
  payload,
});

// FOOD_MENU_ITEM_DATA
export const foodMenuItemData = (payload) => ({
  type: FOOD_MENU_ITEM_DATA,
  payload,
});

export const foodMenuItemDataSuccess = (payload) => ({
  type: FOOD_MENU_ITEM_DATA_SUCCESS,
  payload,
});

export const foodMenuItemDataFail = (payload) => ({
  type: FOOD_MENU_ITEM_DATA_FAIL,
  payload,
});

// FOOD_MENU_ITEM_CREATE
export const foodMenuItemCreate = (payload) => ({
  type: FOOD_MENU_ITEM_CREATE,
  payload,
});

export const foodMenuItemCreateSuccess = (payload) => ({
  type: FOOD_MENU_ITEM_CREATE_SUCCESS,
  payload,
});

export const foodMenuItemCreateFail = (payload) => ({
  type: FOOD_MENU_ITEM_CREATE_FAIL,
  payload,
});

// FOOD_MENU_ITEM_UPDATE
export const foodMenuItemUpdate = (payload) => ({
  type: FOOD_MENU_ITEM_UPDATE,
  payload,
});

export const foodMenuItemUpdateSuccess = (payload) => ({
  type: FOOD_MENU_ITEM_UPDATE_SUCCESS,
  payload,
});

export const foodMenuItemUpdateFail = (payload) => ({
  type: FOOD_MENU_ITEM_UPDATE_FAIL,
  payload,
});

// FOOD_MENU_ITEM_DELETE
export const foodMenuItemDelete = (payload) => ({
  type: FOOD_MENU_ITEM_DELETE,
  payload,
});

export const foodMenuItemDeleteSuccess = (payload) => ({
  type: FOOD_MENU_ITEM_DELETE_SUCCESS,
  payload,
});

export const foodMenuItemDeleteFail = (payload) => ({
  type: FOOD_MENU_ITEM_DELETE_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_STATUS_LIST
export const foodPreOrderEventStatusList = (payload) => ({
  type: FOOD_PREORDER_EVENT_STATUS_LIST,
  payload,
});

export const foodPreOrderEventStatusListSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_STATUS_LIST_SUCCESS,
  payload,
});

export const foodPreOrderEventStatusListFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_STATUS_LIST_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_STATUS_DATA
export const foodPreOrderEventStatusData = (payload) => ({
  type: FOOD_PREORDER_EVENT_STATUS_DATA,
  payload,
});

export const foodPreOrderEventStatusDataSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_STATUS_DATA_SUCCESS,
  payload,
});

export const foodPreOrderEventStatusDataFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_STATUS_DATA_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_STATUS_CREATE
export const foodPreOrderEventStatusCreate = (payload) => ({
  type: FOOD_PREORDER_EVENT_STATUS_CREATE,
  payload,
});

export const foodPreOrderEventStatusCreateSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_STATUS_CREATE_SUCCESS,
  payload,
});

export const foodPreOrderEventStatusCreateFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_STATUS_CREATE_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_STATUS_UPDATE
export const foodPreOrderEventStatusUpdate = (payload) => ({
  type: FOOD_PREORDER_EVENT_STATUS_UPDATE,
  payload,
});

export const foodPreOrderEventStatusUpdateSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_STATUS_UPDATE_SUCCESS,
  payload,
});

export const foodPreOrderEventStatusUpdateFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_STATUS_UPDATE_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_STATUS_DELETE
export const foodPreOrderEventStatusDelete = (payload) => ({
  type: FOOD_PREORDER_EVENT_STATUS_DELETE,
  payload,
});

export const foodPreOrderEventStatusDeleteSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_STATUS_DELETE_SUCCESS,
  payload,
});

export const foodPreOrderEventStatusDeleteFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_STATUS_DELETE_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_TYPE_LIST
export const foodPreOrderEventTypeList = (payload) => ({
  type: FOOD_PREORDER_EVENT_TYPE_LIST,
  payload,
});

export const foodPreOrderEventTypeListSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_TYPE_LIST_SUCCESS,
  payload,
});

export const foodPreOrderEventTypeListFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_TYPE_LIST_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_TYPE_DATA
export const foodPreOrderEventTypeData = (payload) => ({
  type: FOOD_PREORDER_EVENT_TYPE_DATA,
  payload,
});

export const foodPreOrderEventTypeDataSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_TYPE_DATA_SUCCESS,
  payload,
});

export const foodPreOrderEventTypeDataFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_TYPE_DATA_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_TYPE_CREATE
export const foodPreOrderEventTypeCreate = (payload) => ({
  type: FOOD_PREORDER_EVENT_TYPE_CREATE,
  payload,
});

export const foodPreOrderEventTypeCreateSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_TYPE_CREATE_SUCCESS,
  payload,
});

export const foodPreOrderEventTypeCreateFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_TYPE_CREATE_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_TYPE_UPDATE
export const foodPreOrderEventTypeUpdate = (payload) => ({
  type: FOOD_PREORDER_EVENT_TYPE_UPDATE,
  payload,
});

export const foodPreOrderEventTypeUpdateSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_TYPE_UPDATE_SUCCESS,
  payload,
});

export const foodPreOrderEventTypeUpdateFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_TYPE_UPDATE_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_TYPE_DELETE
export const foodPreOrderEventTypeDelete = (payload) => ({
  type: FOOD_PREORDER_EVENT_TYPE_DELETE,
  payload,
});

export const foodPreOrderEventTypeDeleteSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_TYPE_DELETE_SUCCESS,
  payload,
});

export const foodPreOrderEventTypeDeleteFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_TYPE_DELETE_FAIL,
  payload,
});

// FOOD_MENU_TYPE_LIST
export const foodMenuTypeList = (payload) => ({
  type: FOOD_MENU_TYPE_LIST,
  payload,
});

export const foodMenuTypeListSuccess = (payload) => ({
  type: FOOD_MENU_TYPE_LIST_SUCCESS,
  payload,
});

export const foodMenuTypeListFail = (payload) => ({
  type: FOOD_MENU_TYPE_LIST_FAIL,
  payload,
});

// FOOD_MENU_TYPE_DATA
export const foodMenuTypeData = (payload) => ({
  type: FOOD_MENU_TYPE_DATA,
  payload,
});

export const foodMenuTypeDataSuccess = (payload) => ({
  type: FOOD_MENU_TYPE_DATA_SUCCESS,
  payload,
});

export const foodMenuTypeDataFail = (payload) => ({
  type: FOOD_MENU_TYPE_DATA_FAIL,
  payload,
});

// FOOD_MENU_TYPE_CREATE
export const foodMenuTypeCreate = (payload) => ({
  type: FOOD_MENU_TYPE_CREATE,
  payload,
});

export const foodMenuTypeCreateSuccess = (payload) => ({
  type: FOOD_MENU_TYPE_CREATE_SUCCESS,
  payload,
});

export const foodMenuTypeCreateFail = (payload) => ({
  type: FOOD_MENU_TYPE_CREATE_FAIL,
  payload,
});

// FOOD_MENU_TYPE_UPDATE
export const foodMenuTypeUpdate = (payload) => ({
  type: FOOD_MENU_TYPE_UPDATE,
  payload,
});

export const foodMenuTypeUpdateSuccess = (payload) => ({
  type: FOOD_MENU_TYPE_UPDATE_SUCCESS,
  payload,
});

export const foodMenuTypeUpdateFail = (payload) => ({
  type: FOOD_MENU_TYPE_UPDATE_FAIL,
  payload,
});

// FOOD_MENU_TYPE_DELETE
export const foodMenuTypeDelete = (payload) => ({
  type: FOOD_MENU_TYPE_DELETE,
  payload,
});

export const foodMenuTypeDeleteSuccess = (payload) => ({
  type: FOOD_MENU_TYPE_DELETE_SUCCESS,
  payload,
});

export const foodMenuTypeDeleteFail = (payload) => ({
  type: FOOD_MENU_TYPE_DELETE_FAIL,
  payload,
});

// FOOD_PREORDER_SITE_LOCATION_LIST
export const foodPreOrderSiteLocationList = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_LIST,
  payload,
});

export const foodPreOrderSiteLocationListSuccess = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_LIST_SUCCESS,
  payload,
});

export const foodPreOrderSiteLocationListFail = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_LIST_FAIL,
  payload,
});

// FOOD_PREORDER_SITE_LOCATION_DATA
export const foodPreOrderSiteLocationData = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_DATA,
  payload,
});

export const foodPreOrderSiteLocationDataSuccess = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_DATA_SUCCESS,
  payload,
});

export const foodPreOrderSiteLocationDataFail = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_DATA_FAIL,
  payload,
});

// FOOD_PREORDER_SITE_LOCATION_CREATE
export const foodPreOrderSiteLocationCreate = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_CREATE,
  payload,
});

export const foodPreOrderSiteLocationCreateSuccess = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_CREATE_SUCCESS,
  payload,
});

export const foodPreOrderSiteLocationCreateFail = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_CREATE_FAIL,
  payload,
});

// FOOD_PREORDER_SITE_LOCATION_UPDATE
export const foodPreOrderSiteLocationUpdate = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_UPDATE,
  payload,
});

export const foodPreOrderSiteLocationUpdateSuccess = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_UPDATE_SUCCESS,
  payload,
});

export const foodPreOrderSiteLocationUpdateFail = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_UPDATE_FAIL,
  payload,
});

// FOOD_PREORDER_SITE_LOCATION_DELETE
export const foodPreOrderSiteLocationDelete = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_DELETE,
  payload,
});

export const foodPreOrderSiteLocationDeleteSuccess = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_DELETE_SUCCESS,
  payload,
});

export const foodPreOrderSiteLocationDeleteFail = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_DELETE_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE
export const foodPreOrderEventGuestToFoodMenuItemCreate = (payload, token) => ({
  type: FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE,
  payload,
  token,
});

export const foodPreOrderEventGuestToFoodMenuItemCreateSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE_SUCCESS,
  payload,
});

export const foodPreOrderEventGuestToFoodMenuItemCreateFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GUEST_ACCEPT
export const foodPreOrderEventGuestAccept = (payload, token) => ({
  type: FOOD_PREORDER_EVENT_GUEST_ACCEPT,
  payload,
  token,
});

export const foodPreOrderEventGuestAcceptSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_ACCEPT_SUCCESS,
  payload,
});

export const foodPreOrderEventGuestAcceptFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_ACCEPT_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GUEST_DECLINE
export const foodPreOrderEventGuestDecline = (payload, token) => ({
  type: FOOD_PREORDER_EVENT_GUEST_DECLINE,
  payload,
  token,
});

export const foodPreOrderEventGuestDeclineSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_DECLINE_SUCCESS,
  payload,
});

export const foodPreOrderEventGuestDeclineFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_DECLINE_FAIL,
  payload,
});

//FOOD_MENU_SEARCH
export const foodMenuSearch = (payload, token) => ({
  type: FOOD_MENU_SEARCH,
  payload,
  token,
});

export const foodMenuSearchSuccess = (payload) => ({
  type: FOOD_MENU_SEARCH_SUCCESS,
  payload,
});

export const foodMenuSearchFail = (payload) => ({
  type: FOOD_MENU_SEARCH_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY
export const foodPreOrderEventEmailOrganiserEventReady = (payload) => ({
  type: FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY,
  payload,
});

export const foodPreOrderEventEmailOrganiserEventReadySuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY_SUCCESS,
  payload,
});

export const foodPreOrderEventEmailOrganiserEventReadyFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND
export const foodPreOrderEventGuestInviteResend = (payload, token) => ({
  type: FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND,
  payload,
  token,
});

export const foodPreOrderEventGuestInviteResendSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND_SUCCESS,
  payload,
});

export const foodPreOrderEventGuestInviteResendFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED
export const foodPreOrderEventPdfGuestListConfirmed = (payload) => ({
  type: FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED,
  payload,
});

export const foodPreOrderEventPdfGuestListConfirmedSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED_SUCCESS,
  payload,
});

export const foodPreOrderEventPdfGuestListConfirmedFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN
export const foodPreOrderEventPdfKitchenMealPlan = (payload) => ({
  type: FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN,
  payload,
});

export const foodPreOrderEventPdfKitchenMealPlanSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN_SUCCESS,
  payload,
});

export const foodPreOrderEventPdfKitchenMealPlanFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS
export const foodPreOrderEventPdfTableTentCards = (payload) => ({
  type: FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS,
  payload,
});

export const foodPreOrderEventPdfTableTentCardsSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS_SUCCESS,
  payload,
});

export const foodPreOrderEventPdfTableTentCardsFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST
export const foodPreOrderEventRecentActivityList = (payload) => ({
  type: FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST,
  payload,
});

export const foodPreOrderEventRecentActivityListSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_SUCCESS,
  payload,
});

export const foodPreOrderEventRecentActivityListFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_COMMUNICATION_LIST
export const foodPreOrderEventCommunicationList = (payload) => ({
  type: FOOD_PREORDER_EVENT_COMMUNICATION_LIST,
  payload,
});

export const foodPreOrderEventCommunicationListSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_COMMUNICATION_LIST_SUCCESS,
  payload,
});

export const foodPreOrderEventCommunicationListFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_COMMUNICATION_LIST_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH
export const foodPreOrderEventAttachmentSearch = (payload) => ({
  type: FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH,
  payload,
});

export const foodPreOrderEventAttachmentSearchSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH_SUCCESS,
  payload,
});

export const foodPreOrderEventAttachmentSearchFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_ATTACHMENT_DELETE
export const foodPreOrderEventAttachmentDelete = (payload) => ({
  type: FOOD_PREORDER_EVENT_ATTACHMENT_DELETE,
  payload,
});

export const foodPreOrderEventAttachmentDeleteSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_ATTACHMENT_DELETE_SUCCESS,
  payload,
});

export const foodPreOrderEventAttachmentDeleteFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_ATTACHMENT_DELETE_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY
export const foodPreOrderEventSmsOrganiserEventReady = (payload) => ({
  type: FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY,
  payload,
});

export const foodPreOrderEventSmsOrganiserEventReadySuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY_SUCCESS,
  payload,
});

export const foodPreOrderEventSmsOrganiserEventReadyFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY_FAIL,
  payload,
});

// FOOD_MENU_ITEM_SEARCH
export const foodMenuItemSearch = (payload, token) => ({
  type: FOOD_MENU_ITEM_SEARCH,
  payload,
  token,
});

export const foodMenuItemSearchSuccess = (payload) => ({
  type: FOOD_MENU_ITEM_SEARCH_SUCCESS,
  payload,
});

export const foodMenuItemSearchFail = (payload) => ({
  type: FOOD_MENU_ITEM_SEARCH_FAIL,
  payload,
});

// food front of house meal plan
export const foodPreOrderEventPdfFrontOfHouseMealPlan = (payload) => ({
  type: FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN,
  payload,
});

export const foodPreOrderEventPdfFrontOfHouseMealPlanSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS,
  payload,
});

export const foodPreOrderEventPdfFrontOfHouseMealPlanFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN_FAIL,
  payload,
});

//FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST
export const foodPreOrderEventGuestPaymentList = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST,
  payload,
});

export const foodPreOrderEventGuestPaymentListSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST_SUCCESS,
  payload,
});

export const foodPreOrderEventGuestPaymentListFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST_FAIL,
  payload,
});

//FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH
export const foodPreOrderEventGuestPaymentSearch = (payload, token) => ({
  type: FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH,
  payload,
  token,
});

export const foodPreOrderEventGuestPaymentSearchSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH_SUCCESS,
  payload,
});

export const foodPreOrderEventGuestPaymentSearchFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GROUP_LIST
export const foodPreOrderEventGroupList = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_LIST,
  payload,
});

export const foodPreOrderEventGroupListSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_LIST_SUCCESS,
  payload,
});

export const foodPreOrderEventGroupListFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_LIST_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GROUP_DATA
export const foodPreOrderEventGroupData = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_DATA,
  payload,
});

export const foodPreOrderEventGroupDataSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_DATA_SUCCESS,
  payload,
});

export const foodPreOrderEventGroupDataFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_DATA_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GROUP_CREATE
export const foodPreOrderEventGroupCreate = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CREATE,
  payload,
});

export const foodPreOrderEventGroupCreateSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CREATE_SUCCESS,
  payload,
});

export const foodPreOrderEventGroupCreateFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CREATE_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GROUP_UPDATE
export const foodPreOrderEventGroupUpdate = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_UPDATE,
  payload,
});

export const foodPreOrderEventGroupUpdateSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_UPDATE_SUCCESS,
  payload,
});

export const foodPreOrderEventGroupUpdateFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_UPDATE_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GROUP_DELETE
export const foodPreOrderEventGroupDelete = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_DELETE,
  payload,
});

export const foodPreOrderEventGroupDeleteSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_DELETE_SUCCESS,
  payload,
});

export const foodPreOrderEventGroupDeleteFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_DELETE_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA
export const foodPreOrderEventRecentActivityListData = (payload) => ({
  type: FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA,
  payload,
});

export const foodPreOrderEventRecentActivityListDataSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA_SUCCESS,
  payload,
});

export const foodPreOrderEventRecentActivityListDataFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN
export const foodPreOrderEventGroupPdfKitchenMealPlan = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN,
  payload,
});

export const foodPreOrderEventGroupPdfKitchenMealPlanSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN_SUCCESS,
  payload,
});

export const foodPreOrderEventGroupPdfKitchenMealPlanFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN
export const foodPreOrderEventGroupPdfFrontOfHouseMealPlan = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN,
  payload,
});

export const foodPreOrderEventGroupPdfFrontOfHouseMealPlanSuccess = (
  payload
) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS,
  payload,
});

export const foodPreOrderEventGroupPdfFrontOfHouseMealPlanFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS
export const foodPreOrderEventGroupPdfTableTentCards = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS,
  payload,
});

export const foodPreOrderEventGroupPdfTableTentCardsSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS_SUCCESS,
  payload,
});

export const foodPreOrderEventGroupPdfTableTentCardsFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED
export const foodPreOrderEventGroupPdfGuestListConfirmed = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED,
  payload,
});

export const foodPreOrderEventGroupPdfGuestListConfirmedSuccess = (
  payload
) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED_SUCCESS,
  payload,
});

export const foodPreOrderEventGroupPdfGuestListConfirmedFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST
export const foodPreOrderEventGroupPdfTablePlanList = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST,
  payload,
});

export const foodPreOrderEventGroupPdfTablePlanListSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST_SUCCESS,
  payload,
});

export const foodPreOrderEventGroupPdfTablePlanListFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN
export const foodPreOrderEventGroupCsvKitchenMealPlan = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN,
  payload,
});

export const foodPreOrderEventGroupCsvKitchenMealPlanSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN_SUCCESS,
  payload,
});

export const foodPreOrderEventGroupCsvKitchenMealPlanFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN
export const foodPreOrderEventGroupCsvFrontOfHouseMealPlan = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN,
  payload,
});

export const foodPreOrderEventGroupCsvFrontOfHouseMealPlanSuccess = (
  payload
) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS,
  payload,
});

export const foodPreOrderEventGroupCsvFrontOfHouseMealPlanFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED
export const foodPreOrderEventGroupCsvGuestListConfirmed = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED,
  payload,
});

export const foodPreOrderEventGroupCsvGuestListConfirmedSuccess = (
  payload
) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED_SUCCESS,
  payload,
});

export const foodPreOrderEventGroupCsvGuestListConfirmedFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED_FAIL,
  payload,
});

// FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST
export const foodPreOrderEventGroupCsvTablePlanList = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST,
  payload,
});

export const foodPreOrderEventGroupCsvTablePlanListSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST_SUCCESS,
  payload,
});

export const foodPreOrderEventGroupCsvTablePlanListFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST_FAIL,
  payload,
});

//FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN
export const foodPreOrderEventCsvKitchenMealPlan = (payload) => ({
  type: FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN,
  payload,
});

export const foodPreOrderEventCsvKitchenMealPlanSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN_SUCCESS,
  payload,
});

export const foodPreOrderEventCsvKitchenMealPlanFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN_FAIL,
  payload,
});

//FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN
export const foodPreOrderEventCsvFrontOfHouseMealPlan = (payload) => ({
  type: FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN,
  payload,
});

export const foodPreOrderEventCsvFrontOfHouseMealPlanSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS,
  payload,
});

export const foodPreOrderEventCsvFrontOfHouseMealPlanFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN_FAIL,
  payload,
});

//FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED
export const foodPreOrderEventCsvGuestListConfirmed = (payload) => ({
  type: FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED,
  payload,
});

export const foodPreOrderEventCsvGuestListConfirmedSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED_SUCCESS,
  payload,
});

export const foodPreOrderEventCsvGuestListConfirmedFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED_FAIL,
  payload,
});

//FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE
export const foodPreOrderEventGroupCsvDrinkListByTable = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE,
  payload,
});

export const foodPreOrderEventGroupCsvDrinkListByTableSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE_SUCCESS,
  payload,
});

export const foodPreOrderEventGroupCsvDrinkListByTableFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE_FAIL,
  payload,
});

//FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE
export const foodPreOrderEventGroupPdfDrinkListByTable = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE,
  payload,
});

export const foodPreOrderEventGroupPdfDrinkListByTableSuccess = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE_SUCCESS,
  payload,
});

export const foodPreOrderEventGroupPdfDrinkListByTableFail = (payload) => ({
  type: FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE_FAIL,
  payload,
});

//FOOD_PREORDER_SITE_LOCATION_SEARCH
export const foodPreOrderSiteLocationSearch = (payload, token) => ({
  type: FOOD_PREORDER_SITE_LOCATION_SEARCH,
  payload,
  token,
});

export const foodPreOrderSiteLocationSearchSuccess = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_SEARCH_SUCCESS,
  payload,
});

export const foodPreOrderSiteLocationSearchFail = (payload) => ({
  type: FOOD_PREORDER_SITE_LOCATION_SEARCH_FAIL,
  payload,
});

//FOOD_MENU_CLONE
export const foodMenuClone = (payload) => ({
  type: FOOD_MENU_CLONE,
  payload,
});
export const foodMenuCloneSuccess = (payload) => ({
  type: FOOD_MENU_CLONE_SUCCESS,
  payload,
});
export const foodMenuCloneFail = (payload) => ({
  type: FOOD_MENU_CLONE_FAIL,
  payload,
});
